export const testServerURL = "https://9q8hyb14k0.execute-api.eu-central-1.amazonaws.com/test";
export const prodServerURL = "https://smc9j46969.execute-api.eu-central-1.amazonaws.com/prod";

export const getServerURL = () => {
    if (process.env.REACT_APP_SERVER === "prod") {
        return prodServerURL;
    }
    return testServerURL;
};
